
//STYLE
import { faCheck, faMinus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckBoxWrapper } from "./styled";
import React from "react";

//PROPS
interface Props {
    label?: string;
    isChecked: boolean;
    isIndeterminate?: boolean;
    trigger: React.Dispatch<React.SetStateAction<boolean>>;
    disabled?: boolean;
    onCheckClick?: Function;
    onMouseOver?: Function;
    onMouseOut?: Function;
    onlyCheckBox?: boolean;
    style?: React.CSSProperties;
    danger?: boolean;
}

const Checkbox: React.FC<Props> = ({ label, isChecked, trigger, disabled, onCheckClick, onMouseOver, onMouseOut, onlyCheckBox, style, isIndeterminate, danger }) => {
    return (
        <CheckBoxWrapper style={{width: onlyCheckBox?16:undefined, ...style}}>
            <button //nosonar
                role="checkbox" //nosonar
                className="CheckBoxWrapper__ckeckbox"
                data-checked={isChecked || isIndeterminate}
                onClick={()=>{trigger(!isChecked);onCheckClick?.()}}
                onBlur={()=>{}}
                onFocus={()=>{}}
                onMouseOver={()=>onMouseOver?.()}
                onMouseOut={()=>onMouseOut?.()}
                disabled={disabled}
                data-danger={danger}
            >
                {(isChecked&&!isIndeterminate) && <FontAwesomeIcon icon={faCheck} />}
                {(isIndeterminate) && <FontAwesomeIcon icon={faMinus} />}
            </button>

            {!!label &&(
                <label className="CheckBoxWrapper__label">
                    {label}
                </label>
            )}
        </CheckBoxWrapper>
    )
};

export default Checkbox;